export default onAfterRenderClient

// Remove the static boot overlay (injected via `+config.ts` `bodyHtmlBegin`) once the SPA has
// rendered. Vike awaits `+data.client.ts` before the first client render, so this fires only
// after the auth + dashboard load has resolved — revealing a ready page rather than a blank
// screen, with no flash of <Login>. Runs after every client render; a harmless no-op once the
// element is gone.
function onAfterRenderClient(): void {
  document.getElementById('boot-loader')?.remove()
}
